import { render, staticRenderFns } from "./CountdownContainer.vue?vue&type=template&id=5ef63da4&scoped=true&"
import script from "./CountdownContainer.vue?vue&type=script&lang=js&"
export * from "./CountdownContainer.vue?vue&type=script&lang=js&"
import style0 from "./CountdownContainer.vue?vue&type=style&index=0&id=5ef63da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef63da4",
  null
  
)

export default component.exports